import { render, staticRenderFns } from "./ShiftManagementWidget.vue?vue&type=template&id=557f510c&scoped=true&"
import script from "./ShiftManagementWidget.vue?vue&type=script&lang=js&"
export * from "./ShiftManagementWidget.vue?vue&type=script&lang=js&"
import style0 from "./ShiftManagementWidget.vue?vue&type=style&index=0&id=557f510c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557f510c",
  null
  
)

export default component.exports